/*
  Opruimer voor de oude gratis-cadeau-actie.

  Tot 21 september 2026 voegde dit script bij €70 automatisch een Brownie Box
  toe met de property _zazu_gratis. Die actie is vervangen door een €5-bon voor
  de volgende bestelling, dus er wordt niets meer toegevoegd.

  Wat blijft: winkelwagens die nog een door ons toegevoegde regel bevatten
  moeten die kwijt. De bijbehorende automatische korting staat uit, dus zo'n
  regel zou nu gewoon afgerekend worden. Alleen regels met _zazu_gratis worden
  verwijderd; een Brownie Box die de klant zelf koos blijft staan.

  Dit bestand mag leeg zodra er geen oude winkelwagens meer rondzweven,
  in de praktijk een week of zes na 21 september 2026.
*/
if (typeof ZazuGratisCadeau !== 'function') {

  class ZazuGratisCadeau extends HTMLElement {

    connectedCallback() {
      // Wacht een tik zodat beide instanties (drawer + pagina) niet tegelijk starten
      setTimeout(() => this.opruimen(), 50);
    }

    async opruimen() {
      if (window._zazuCadeauBezig || !this.isConnected) return;
      window._zazuCadeauBezig = true;
      let ietsGedaan = false;

      try {
        ['1', '2'].forEach(tier => {
          sessionStorage.removeItem('zazuCadeauAdded' + tier);
          sessionStorage.removeItem('zazuCadeauDismissed' + tier);
        });

        const cart = await (await fetch('/cart.js')).json();
        const eigenLines = cart.items.filter(i => i.properties && i.properties._zazu_gratis);

        for (const line of eigenLines) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: line.key, quantity: 0 })
          });
          ietsGedaan = true;
        }
      } catch (e) {
        console.log('zazu-gratis-cadeau:', e);
      } finally {
        window._zazuCadeauBezig = false;
        if (ietsGedaan && typeof window.refreshCart === 'function') {
          window.refreshCart(false);
        }
      }
    }

  }

  if (typeof customElements.get('zazu-gratis-cadeau') === 'undefined') {
    customElements.define('zazu-gratis-cadeau', ZazuGratisCadeau);
  }

}
